// Resolve first-party display copy, never historical addresses or identities.
const escapeRegex = value => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const addresses = /https?:\/\/[^\s<>"')]+|mailto:[^\s<>"')]+|[\w.+-]+@[\w.-]+\.[a-z]{2,}|(?:www\.)?(?:[\w-]+\.)+[a-z]{2,63}\b[^\s<>"')]*|\/[a-z0-9_~%./?#=&+-]+/gi;

export function resolveBrandText(value, activeName, legacyName) {
  if (activeName === legacyName || !value) return value;
  const name = new RegExp(escapeRegex(legacyName), "gi");
  const combined = new RegExp(`${escapeRegex(legacyName)}\\s+by\\s+${escapeRegex(activeName)}`, "gi");
  // Preserve Markdown destinations, email addresses and actual URL authority.
  const pieces = value.split(new RegExp(`(${addresses.source})`, addresses.flags));
  return pieces.map((part, index) => index % 2 ? part :
    part.replace(combined, activeName).replace(name, activeName)).join("");
}

export function resolveBrandHtml(value, activeName, legacyName) {
  if (activeName === legacyName) return value;
  return value.split(/(<(?:script|style)\b[^>]*>[\s\S]*?<\/(?:script|style)>|<[^>]+>)/gi)
    .map((part, index) => {
      if (!(index % 2)) return resolveBrandText(part, activeName, legacyName);
      if (/^<(?:script|style)\b/i.test(part)) return part;
      return part.replace(/(\b(?:alt|title|aria-label)\s*=\s*)(["'])(.*?)\2/gi,
        (_, prefix, quote, text) => `${prefix}${quote}${resolveBrandText(text, activeName, legacyName)}${quote}`);
    }).join("");
}

const identityFields = /^(?:id|slug|.*(?:url|href|path|email)|src|srcSet|brand|platform|locale|market|country.*|.*(?:Id|At)|cars|reviews|quotes|fixedInventory|searchState)$/i;
export function resolveBrandContent(value, activeName, legacyName, field = "") {
  if (activeName === legacyName || identityFields.test(field)) return value;
  if (typeof value === "string") return /html/i.test(field) || /<[a-z][^>]*>/i.test(value)
    ? resolveBrandHtml(value, activeName, legacyName)
    : resolveBrandText(value, activeName, legacyName);
  if (Array.isArray(value)) return value.map(item => resolveBrandContent(item, activeName, legacyName));
  if (value && typeof value === "object" && !value.$$typeof && Object.getPrototypeOf(value) === Object.prototype)
    return Object.fromEntries(Object.entries(value).map(([key, item]) =>
      [key, resolveBrandContent(item, activeName, legacyName, key)]));
  return value;
}
